import React from 'react';
import './aside.css';   

const Aside = () => {
    return (
        <div className='marqueeAsideContainer'> 
            <span className='marqueeAsideText'>
            ∞ This is my portfolio, my lab, and my resume all in one. Here, you'll find projects, experiments, and ideas I've been tinkering with. ∞ 
            </span>
        </div>
    );
};

export default Aside;
